import { combineReducers } from 'redux'
import simpleEntityReducer from './simpleEntityReducer'
import translatedEntityReducer from './translatedEntityReducer'
import ingredients from './ingredients'
import recipes from './recipes'
import labellevels from './labellevels'
import session from './session'
import users from './users'

const appReducer = combineReducers({
  locales: simpleEntityReducer('locale'),
  regions: translatedEntityReducer('region'),
  appliances: translatedEntityReducer('appliance'),
  applianceTypes: simpleEntityReducer('applianceType'),
  foodKinds: translatedEntityReducer('foodKind'),
  libraryTexts: translatedEntityReducer('libraryText'),
  tags: translatedEntityReducer('tag'),
  tagTypes: translatedEntityReducer('tagType'),
  units: translatedEntityReducer('unit'),
  session,
  ingredients,
  recipes,
  labellevels,
  users,
})

export default (state, action) => appReducer(state, action)
